module.exports = __webpack_public_path__ + "img/check.96a5a08b.png";